"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.diyListApi = diyListApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 提现申请 列表
 * @param pram
 */
function diyListApi(params) {
  return (0, _request.default)({
    url: '/admin/pagediy/list',
    method: 'get',
    params: params
  });
}